export default {"src":"https://static.jusbr.com/web/docview/_next/static/media/erro.1eb386cd.svg","height":141,"width":140,"blurWidth":0,"blurHeight":0};